import { useAIRovoButtonEnablement } from '@confluence/ai-common/entry-points/useAIRovoButtonEnablement.ts';
import { fg } from '@confluence/feature-gating';
import { PageMode } from '@confluence/page-utils/entry-points/enums.ts';
import { useGetPageMode } from '@confluence/page-utils/entry-points/useGetPageMode.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

/**
 * Hook to determine if nudge recommendation checks should be enabled for live docs
 *
 * @param contentType - The type of content (e.g., 'page', 'blogpost')
 * @param _contentId - The ID of the content (currently unused, reserved for future read-time filter)
 * @returns boolean indicating if nudge recommendation checks are enabled for live docs
 */
export const useLiveDocNudgeRecommendationFilter = (
	contentType: string,
	_contentId: string,
): boolean => {
	const { isAdminHubAIEnabled } = useSessionData();
	const pageMode = useGetPageMode();
	const isRovoButtonEnabled = useAIRovoButtonEnablement();

	const isLiveDoc = pageMode === PageMode.LIVE;

	/**
	 * Filters to prevent high request volume checking for nudge recommendations on live docs
	 * 1. Feature gate 'confluence_rovo_live_doc_nudges' must be enabled
	 * 2. Page must be a live doc
	 * 3. Rovo Button must be enabled
	 * 4. Content type must be 'page'
	 */
	return (
		isLiveDoc &&
		isRovoButtonEnabled &&
		contentType === 'page' &&
		isAdminHubAIEnabled &&
		fg('confluence_rovo_live_doc_nudges')
	);
};
